module.exports = __webpack_public_path__ + "img/glm_gbt810_1988.prt.bfbc7c85.jpg";